import './navigation-strip.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initNavigationStrip = (context) => {
  const navigationStripSection = context.closest('.shopify-section');
  if (!navigationStripSection) return;

  const slider = navigationStripSection.querySelector('.navigation-strip__scroll-wrapper');
  if (slider) {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1;
      slider.scrollLeft = scrollLeft - walk;
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.navigation-strip__container'), (el) => {
    window.dAgency.initNavigationStrip(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.navigation-strip__container'), (el) => {
      window.dAgency.initNavigationStrip(el);
    });
  });
}
